import React, { KeyboardEvent, forwardRef, useState } from 'react';
import { InputProps } from './Input.types';
import { InputBase } from './Input.ui';
import { Flex, Text } from '../../index.ts';
import VisibilityEyeClosed from '@keyslabor/shared/assets/svgComponents/VisibilityEyeClosed';
import VisibilityEye from '@keyslabor/shared/assets/svgComponents/VisibilityEye';
import { parseNumeric, parseNumericWithDecimal } from '@keyslabor/shared/utils';
import { format } from 'date-fns';
import { useIsMobile } from '../../../hooks/useBreakPoint.ts';

export const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      name,
      value,
      type = 'text',
      shape = 'default',
      disabled,
      required,
      onChange,
      label,
      Icon,
      isNumber,
      margin,
      helpertext,
      isDecimal = true,
      isDate,
      placeholderColor,
      maxChars,
      ...restProps
    },
    ref
  ) => {
    const noClick = !!disabled;
    const [visible, setVisible] = useState<boolean>(false);
    const isMobile = useIsMobile();

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const { value: inputValue } = e.target;

      if (!isNumber) {
        onChange(e);
        return;
      }

      if (isDecimal) {
        e.target.value = parseNumericWithDecimal(inputValue);
      } else {
        e.target.value = parseNumeric(inputValue);
      }

      onChange(e);
    };

    const handleFormat = (val) => {
      if (isDate && val) {
        return format(new Date(val), 'MM/dd/yyy').toString();
      }

      return val;
    };

    return (
      <Flex flexDirection={'column'} margin={margin}>
        {label ? (
          <Flex>
            <Text
              fontSize={isMobile ? '16px' : '14px'}
              fontWeight="500"
              mb="6px"
            >
              {label}
            </Text>
            {required ? (
              <Text color="#EB5757" ml="2px">
                *
              </Text>
            ) : null}
          </Flex>
        ) : null}
        <Flex position="relative">
          <InputBase
            name={name}
            disabled={disabled}
            onChange={!noClick ? handleChange : undefined}
            type={visible ? 'text' : type}
            value={handleFormat(value)}
            shape={shape}
            height="40px"
            prefix={Icon}
            placeholderColor={placeholderColor}
            {...restProps}
          />
          {type === 'password' && (
            <Flex
              position="absolute"
              height="100%"
              right="10px"
              alignItems="center"
              style={{ cursor: 'pointer' }}
              onClick={() => setVisible(!visible)}
            >
              {visible ? <VisibilityEyeClosed /> : <VisibilityEye />}
            </Flex>
          )}
        </Flex>
        {helpertext && (
          <Text fontSize="12px" opacity={'0.5'} mt="5px">
            {helpertext}
          </Text>
        )}
      </Flex>
    );
  }
);

Input.displayName = 'Input';

export default Input;
